<template>
  <div class="ticourses-page">
    <top-navbar></top-navbar>
    <div class="mb-5 ticourses-background">
      <h6 class="manage-boder pt-2 font1 decoration"><router-link class="decoration" to="/">Home</router-link><span
          class="pfimg3"><i class="fa fa-angle-right"></i></span> Internal Courses <span class="pfimg3"><i
            class="fa fa-angle-right"></i></span> {{ isEdit ? 'Update Internal Course' : 'Create Internal Course' }}</h6>
      <div class="container-fluid mt-2">
        <div class="card bdr-rad2 shadow p-2">
          <div class="card-body">
            <div v-if="errorMessage" class="alert alert-danger">{{ errorMessage }}</div>
            <div v-if="successMessage" class="alert alert-success">{{ successMessage }}</div>
            <form @submit.prevent="createCourse">
              <div class="row">
                <div class="col-md-3 form-group"><label>Training Category</label><select
                    v-model="course.training_category" class="form-control form-control-sm bdr-rad">
                    <option value="">Select</option>
                    <option>Internal Safety Training</option>
                    <option>Internal Operation Training</option>
                    <option>Other</option>
                  </select></div>
                <div class="col-md-3 form-group"><label>Course Title <span class="required-mark">*</span></label><input
                    v-model="course.course_title" class="form-control form-control-sm bdr-rad" required></div>
                <div class="col-md-3 form-group"><label>Group <span class="required-mark">*</span></label><select
                    v-model="course.course_group" class="form-control form-control-sm bdr-rad" required>
                    <option value="">Select...</option>
                    <option value="1">Refresher</option>
                    <option value="2">Renewal</option>
                    <option value="3">New</option>
                  </select></div>
                <div class="col-md-3 form-group"><label>Training Center</label><select
                    v-model="course.training_center_id" class="form-control form-control-sm bdr-rad">
                    <option value="">Select...</option>
                    <option v-for="center in trainingCenters" :key="center.value" :value="center.value">{{ center.label
                      }}</option>
                  </select></div>
              </div>
              <div class="row">
                <div class="col-md-3 form-group"><label>Duration <span class="required-mark">*</span></label><input
                    v-model.number="course.duration" type="number" min="0.01" step="0.01"
                    class="form-control form-control-sm bdr-rad" required></div>
                <div class="col-md-3 form-group"><label>Frequency <span class="required-mark">*</span></label><select
                    v-model="course.frequency" class="form-control form-control-sm bdr-rad" required>
                    <option value="">Select...</option>
                    <option>Yearly</option>
                    <option>Every 2 Years</option>
                    <option>Every 3 Years</option>
                    <option>Every 5 Years</option>
                    <option>One Off</option>
                  </select></div>
                <div class="col-md-3 form-group"><label>Allocated Seats <span
                      class="required-mark">*</span></label><input v-model.number="course.allocated_seats" type="number"
                    min="1" class="form-control form-control-sm bdr-rad" @input="syncAvailableSeats" required></div>
                <div class="col-md-3 form-group"><label>Remarks</label><textarea v-model="course.remarks" rows="2"
                    class="form-control form-control-sm bdr-rad"></textarea></div>
              </div>
              <div class="card custom_bdr_rds mt-3 p-2">
               
                 <h6 class="purchitem mb-2"><b>Modules</b></h6>
                <div class="d-flex justify-content-end py-1"><button type="button" class="btn btn-sm btn-outline-primary bdr-rad"
                    @click="addModule">Add Module</button></div>
                <div v-for="(module, index) in course.modules" :key="module.key" class="border rounded p-2 mt-2">
                  <h6 class="purchitem mb-2"><b>Module {{ index + 1 }}</b></h6>
                  <div v-if="course.modules.length > 1" class="d-flex justify-content-end mb-2"><button
                      type="button" class="btn btn-sm btn-outline-primary bdr-rad"
                      @click="removeModule(index)">Remove</button></div>
                  <div class="row">
                    <div class="col-md-3 form-group"><label>Module Name <span
                          class="required-mark">*</span></label><input v-model="module.module_name"
                        class="form-control form-control-sm bdr-rad" required></div>
                    <div class="col-md-3 form-group"><label>Conduct By <span
                          class="required-mark">*</span></label><select v-model="module.conduct_by"
                        class="form-control form-control-sm bdr-rad" required>
                        <option value="">Select Conduct By</option>
                        <option v-for="item in departments" :key="item" :value="item">{{ item }}</option>
                      </select></div>
                    <div class="col-md-2 form-group"><label>Available Seats <span
                          class="required-mark">*</span></label><input v-model.number="module.available_seats"
                        type="number" min="0" class="form-control form-control-sm bdr-rad" disabled required></div>
                    <div class="col-md-2 form-group"><label>Duration <span class="required-mark">*</span></label><input
                        v-model.number="module.duration" type="number" min="0" step="0.01"
                        class="form-control form-control-sm bdr-rad" required></div>
                    <div class="col-md-2 form-group"><label>Per Emp. Cost <span
                          class="required-mark">*</span></label><input v-model.number="module.per_employee_cost"
                        type="number" min="0" step="0.01" class="form-control form-control-sm bdr-rad" required></div>
                  </div>
                  <div class="row">
                    <div class="col-md-6 form-group"><label>Module Remarks</label><textarea v-model="module.remarks"
                        rows="2" class="form-control form-control-sm bdr-rad"></textarea></div>
                  </div>
                  <div class="mt-2">
                   
                     <h6 class="ticourse-subsection-title mb-2">Trainer</h6>
                    <div class="d-flex justify-content-end"><b-icon @click="addTrainer(module)"
                        class="ticourse-action-icon text-dark mt-1 mr-2" icon="plus-lg" scale="1"></b-icon></div>
                    <div v-for="(trainer, trainerIndex) in module.trainers" :key="trainer.key"
                      class="row mt-2">
                      <div class="col-auto form-group mt-2"><b-icon v-if="module.trainers.length > 1"
                          @click="removeTrainer(module, trainerIndex)" class="ticourse-action-icon text-dark mt-4 mr-2" icon="dash-lg"
                          scale="1"></b-icon></div>
                      <div class="col-md-2 form-group"><label>Type</label><select v-model.number="trainer.trainer_type"
                          class="form-control form-control-sm bdr-rad">
                          <option :value="2">Internal</option>
                          <option :value="1">External</option>
                        </select></div>
                      <div class="col-md-3 form-group"><label>Department</label><select v-model="trainer.department"
                          class="form-control form-control-sm bdr-rad">
                          <option value="">Select Department</option>
                          <option v-for="item in departments" :key="item" :value="item">{{ item }}</option>
                        </select></div>
                      <div v-if="trainer.trainer_type === 2" class="col-md-3 form-group"><label>Internal
                          Trainer</label><select v-model="trainer.internal_trainer_id"
                          class="form-control form-control-sm bdr-rad">
                          <option value="">Select Trainer</option>
                          <option v-for="item in trainers" :key="item.value" :value="item.value">{{ item.label }}
                          </option>
                        </select></div>
                      <div v-else class="col-md-3 form-group"><label>External Trainer</label><input
                          v-model="trainer.external_trainer" class="form-control form-control-sm bdr-rad"></div>
                      <div class="col-md-3 form-group"><label>Trainer Remarks</label><input v-model="trainer.remarks"
                          class="form-control form-control-sm bdr-rad"></div>
                    </div>
                  </div>
                  <div class="mt-3">
              
                     <h6 class="ticourse-subsection-title mb-2">Training Material</h6>
                    <div class="d-flex justify-content-end"><b-icon @click="addMaterial(module)"
                        class="ticourse-action-icon text-dark mt-1 mr-2" icon="plus-lg" scale="1"></b-icon></div>
                    <div v-for="(material, materialIndex) in module.materials" :key="material.key"
                      class="row mt-2">
                      <div class="col-auto form-group mt-2"><b-icon v-if="module.materials.length > 1"
                          @click="removeMaterial(module, materialIndex)" class="ticourse-action-icon text-dark mt-4 mr-2" icon="dash-lg"
                          scale="1"></b-icon></div>
                      <div class="col-md-3 form-group"><label>Material Type</label><select
                          v-model="material.material_type" class="form-control form-control-sm bdr-rad">
                          <option value="">Select</option>
                          <option>Trainer Notes</option>
                          <option>Training Handouts</option>
                        </select></div>
                      <div class="col-md-3 form-group"><label>Material Name</label><input
                          v-model="material.resource_name" class="form-control form-control-sm bdr-rad"></div>
                      <div class="col-md-3 form-group"><label>File</label><input type="file"
                          class="form-control form-control-sm bdr-rad" @change="setMaterialFile($event, material)">
                      </div>
                      <div class="col-md-2 form-group"><label>Remarks</label><input v-model="material.remarks"
                          class="form-control form-control-sm bdr-rad"></div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="card custom_bdr_rds mt-3 p-2">
                <h6 class="purchitem mb-2"><b>Capable Job Roles</b></h6>
                <div class="row"><label v-for="role in jobRoles" :key="role" class="col-md-3 mb-1 pl-3 d-flex align-items-center"><input
                      class="mr-1 mt-0"
                      v-model="course.job_roles" type="checkbox" :value="role"> <span>{{ role }}</span></label></div>
              </div>
              <div class="d-flex justify-content-end mt-3"><button type="button" @click="$router.back()"
                  class="btn btn-sm btn-outline-primary bdr-rad mr-2">Back</button><button type="submit"
                  class="btn btn-sm btn-outline-primary bdr-rad" :disabled="isSaving">{{ isSaving ? 'Saving...' :
                  (isEdit ? 'Update' : 'Create') }}</button></div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <content-footer></content-footer>
  </div>
</template>

<script>
  import axios from 'axios';
  import authService from '@/auth.service';
  import TopNavbar from './../../layout/TopNavbar.vue';
  import ContentFooter from './../../layout/ContentFooter.vue';

  const departments = ['WSH', 'Training Department', 'Human Resource(HR)', 'Operations(Company wide)', 'ADMIN - Office Admin', 'TUG - Tug', 'FA - *** Code not found ***', 'OP - Operation', 'SITE - Site', 'SM - Steersman'];
  const trainingCenters = ['EXXON - EXXON MOBIL', 'Pac', 'Pesek', 'OVL 2', 'SAR2', 'Jurong W.D.O', 'Pesek W.D.O', 'EMC Steersman', 'EM Weightbridge', 'vopak Banyan', 'vopak Sakra', 'vopak sakra drumming', 'Vopak Penjuru', 'Penjuru Drumming', 'Horizon Mooring', 'Horizon Grass Cutting', 'Offshore', 'Universal', 'Tankstore', 'Tankstore off', 'BCSS', 'BCSS Janitor', 'Shell', 'Shell driver', 'Shell Berth Attendant', 'SLNG', 'Tuas', 'ADMIN - Finance', 'OPR - OPERATION', 'OPRMGT - OPR - MANAGEMENT', 'WSH - WORK SAFETY & HEALTH', 'TSTUGVIII - TS Tug VIII', 'TSTUGVII - Tug VII', 'Chervon', 'Office', 'Horizon', 'QTEMC', 'QTTS'].map((label, index) => ({ label, value: index + 1 }));
  const trainers = ['S1357178C - LEE AI BENG', 'S7533703E - Huahad Bin Mohamed Mahfuzh', 'S0080556D - CHONG YOKE KIN ROBERT', 'S9238206J - Tang Jian Ting John', 'F7773620N - Tin Maung Latt', 'G8362749U - Nyi Nyi Tun', 'S8611727D - Huang Xinrong', 'F8490344L - Saw Htoo Baw', 'F2412713M - Tin Htut', 'S8336480G - Low Weng Keong'].map((label, index) => ({ label, value: index + 1 }));
  const jobRoles = ['A.FOREMAN', 'ACCOUNT MANAGER', 'ADMIN EXECUTIVE', 'ADMINISTRATOR', 'ADVISOR', 'ASST ACCTS MANAGER', 'ASST HR MANAGER', 'BERTH ATTENDANT', 'BOAT STEERSMAN', 'CLERK', 'DIRECTOR', 'DRIVER', 'Drum Filler', 'FOREMAN', 'FORKLIFT DRIVER', 'GENERAL MANAGER', 'HR MANAGER', 'HR/ADMIN ASSISTANT', 'Human Resource Executive', 'JANITOR', 'Lifting Supervisor', 'Logistics', 'Marketing', 'MOORING CREW', 'Operation Asst', 'OPERATION EXECUTIVE', 'Operation Manager', 'OPERATION MGR', 'ORDINATOR', 'RUNNER', 'SENIOR SUPERVISOR', 'Senior Technical Executive', 'Senior WSH Executive', 'Senior WSH Manager', 'SHE Helper', 'SITE SUPERVISOR', 'TANK FARM WORKER', 'Technician', 'Truck Rack Operator', 'TT', 'Tug 2nd Engineer', 'Tug AB', 'Tug Chief Engineer', 'Tug Chief Officer', 'Tug Master', 'Weighbridge Operator', 'WSH MANAGER'];

  function newTrainer() { return { key: Date.now() + Math.random(), trainer_type: 2, department: '', internal_trainer_id: '', external_trainer: '', remarks: '' }; }
  function newMaterial() { return { key: Date.now() + Math.random(), material_type: '', resource_name: '', file_path: '', remarks: '', file: null }; }
  function newModule() { return { key: Date.now() + Math.random(), module_name: '', conduct_by: '', available_seats: 0, duration: 0, per_employee_cost: 0, remarks: '', trainers: [newTrainer()], materials: [newMaterial()] }; }

  export default {
    components: { TopNavbar, ContentFooter },
    data() { return { token: authService.isLoggedIn(), isSaving: false, isEdit: false, errorMessage: '', successMessage: '', departments, trainingCenters, trainers, jobRoles, course: { training_category: '', course_title: '', course_group: '', is_external: false, training_center_id: '', external_training_center: '', duration: 0, frequency: '', allocated_seats: 1, remarks: '', ite_training: false, modules: [newModule()], job_roles: [] } }; },
    mounted() { if (this.$route.query.edit) this.loadCourseForEdit(this.$route.query.edit); },
    methods: {
      addModule() {
        const module = newModule();
        module.available_seats = this.course.allocated_seats || 0;
        this.course.modules.push(module);
      },
      removeModule(index) { this.course.modules.splice(index, 1); },
      syncAvailableSeats() {
        this.course.modules.forEach((module) => {
          module.available_seats = this.course.allocated_seats || 0;
        });
      },
      addTrainer(module) { module.trainers.push(newTrainer()); },
      removeTrainer(module, index) { module.trainers.splice(index, 1); },
      addMaterial(module) { module.materials.push(newMaterial()); },
      removeMaterial(module, index) { module.materials.splice(index, 1); },
      setMaterialFile(event, material) { const file = event.target.files[0]; material.file = file || null; material.file_path = file ? file.name : ''; },
      async loadCourseForEdit(id) {
        try {
          const { data } = await axios.get('/ticourses/view?id=' + id, { headers: { Authorization: 'Bearer ' + this.token } });
          this.isEdit = true;
          const modules = (data.modules || []).map((module) => ({
            ...module,
            key: Date.now() + Math.random(),
            trainers: (data.trainers || [])
              .filter((trainer) => Number(trainer.module_id) === Number(module.id))
              .map((trainer) => ({ ...trainer, key: Date.now() + Math.random() })),
            materials: (data.materials || [])
              .filter((material) => Number(material.module_id) === Number(module.id))
              .map((material) => ({ ...material, key: Date.now() + Math.random(), file: null })),
          }));
          this.course = {
            ...this.course,
            ...data.course,
            modules,
            job_roles: (data.job_roles || []).map((role) => role.role_name || role),
          };
        } catch (error) { this.errorMessage = 'Unable to load internal course.'; }
      },
      async createCourse() {
        this.isSaving = true; this.errorMessage = ''; this.successMessage = '';
        try {
          const payload = {
            course: { ...this.course, is_external: 0, external_training_center: '', ite_training: 0 },
            modules: this.course.modules.map((module) => ({
              ...module,
              trainers: module.trainers.map((trainer) => ({ ...trainer })),
              materials: module.materials.filter((material) => material.material_type).map((material) => ({ ...material, file: undefined })),
            })),
            job_roles: this.course.job_roles,
          };
          const formData = new FormData();
          formData.append('payload', JSON.stringify(payload));
          this.course.modules.forEach((module, moduleIndex) => {
            module.materials.forEach((material, materialIndex) => {
              if (material.file && material.material_type) formData.append(`material_files[${moduleIndex}][${materialIndex}]`, material.file);
            });
          });
          const { data } = await axios.post('/ticourses/create', formData, { headers: { Authorization: 'Bearer ' + this.token } });
          if (data.status === 200) { this.successMessage = data.message || 'Internal course created successfully.'; this.course = { ...this.course, course_title: '', modules: [newModule()], job_roles: [] }; }
        } catch (error) { this.errorMessage = error.response && error.response.data && error.response.data.message ? error.response.data.message : 'Unable to create internal course.'; } finally { this.isSaving = false; }
      },
    },
  };
</script>

<style>
  .ticourses-page {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
  }

  .ticourses-page .ticourses-background {
    flex: 1 0 auto;
    background: #eaf6ff;
    min-height: calc(100vh - 60px);
  }

  .ticourses-page .bdr-rad {
    border-radius: 12px;
  }

  .ticourses-page .bdr-rad2 {
    border-radius: 15px;
  }

  .ticourses-page .decoration {
    color: #fff !important;
    text-decoration: none;
  }

  .ticourses-page .font1 {
    font-size: 13px !important;
  }

  .ticourses-page .manage-boder {
    background: #087df5;
    color: #fff;
    padding: 10px 15px !important;
    margin: 0 !important;
    line-height: normal;
  }

  .ticourses-page label {
    font-size: small;
    color: #000;
  }

  .ticourses-page .form-control {
    color: #000;
    background-color: #fff;
    border-color: #ced4da;
  }

  .ticourses-page .form-control-sm {
    min-height: calc(1.5em + .75rem + 2px);
    padding: .375rem .75rem;
  }

  .ticourses-page .required-mark {
    color: #dc3545;
  }

  .ticourse-subsection-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: #d9edf7;
    color: #235983;
    padding: 6px 10px;
    border-radius: 4px;
    font-size: small;
    font-weight: 600;
  }

  .ticourse-action-icon {
    cursor: pointer;
  }

  .ticourse-action-icon:hover {
    color: #087df5 !important;
  }

</style>
